<template>
  <div class="content has-text-centered">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child">
          <figure class="image" style="display: inline-block;">
            <img src="~assets/images/vti.png" alt="Image1" style="height: 100px; width: auto; margin-top: 15px;"/>
            <!--<img src="http://placehold.it/128x128" alt="Image">-->
          </figure>
          <div class="columns is-vcentered">
            <div class="login-box">
              <div class="box">
                <div class="has-text-left">
                  <div style="font-size: 20px; font-weight: bold;">
                    Login
                  </div>
                </div>
                <hr style="margin: 10px 0px;">
                <div v-show="error"
                     style="color:red; word-wrap:break-word;">{{ error }}</div>
                <form v-on:submit.prevent="onSubmit">
                  <p class="control">
                    <input v-model="email"
                           class="input"
                           type="text"
                           placeholder="Email">
                  </p>
                  <p class="control">
                    <input v-model="password"
                           class="input"
                           type="password"
                           placeholder="Password">
                  </p>

                  <div class="columns">
                    <div class="column">
                      <p class="control">
                        <label class="checkbox">
                          <input type="checkbox"> Remember me
                        </label>
                      </p>
                    </div>
                    <div class="column">
                      <div class="has-text-right">
                          <router-link :to="'/forgotPassword'">Forgot your password?</router-link>
                      </div>
                    </div>
                  </div>
                  <p class="has-text-centered">
                    <button type="submit" class="button is-primary login-button">Login</button>
                  </p>
                  <div class="separator">
                    <span class="separator-text">OR</span>
                  </div>
                  <g-signin-button :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
                    <span class="google-button__icon">
                      <i class="fa fa-google"></i>
                    </span>
                    <span>|</span>
                    <span class="google-text">&emsp;Sign in with Google</span>
                  </g-signin-button>
                </form>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AuthenticationService from './../../services/authenticationservice'
import Global from '../../services/globalservice'
import Vue from 'vue'
import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

export default {
  data () {
    return {
      email: '',
      password: '',
      error: '',
      googleSignInParams: {
        client_id: Global.GOOGLE_CLIENT_ID,
        prompt: 'select_account'
      }
    }
  },

  // computed property for form validation state
  computed: {
    ...mapGetters({
      authenticated: 'authenticated'
    }),
    validation: function () {
      return {
        email: !!this.email.trim(),
        password: !!this.password.trim()
      }
    }
  },

  // methods
  methods: {
    ...mapActions([
      'doAuthentication'
    ]),
    onSubmit: function () {
      this.error = ''
      if (this.validation.email && this.validation.password) {
        var credentials = {
          email: this.email.trim(),
          password: this.password.trim()
        }
        AuthenticationService.login(this, credentials, 'Home')
      }
    },
    onSignInSuccess: function (googleUser) {
      this.error = ''
      var idToken = googleUser.getAuthResponse().id_token
      AuthenticationService.login(this, {'token': idToken}, 'Home', true)
    },
    onSignInError: function (error) {
      console.log('e', error)
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box {
  width: 450px;
  margin: 10px auto;
}
.login-button {
  width: 100%;
}
.is-title {
  text-transform: capitalize;
}
.separator {
  margin: 20px 0;
  border-top: 1px solid #CCCCCC;
  position: relative;
}
.separator-text {
  display: block;
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -22px;
  padding: 0px 10px;
  background: #FFFFFF;
  color: #8a8a8a;
}
.g-signin-button {
  width: 100%;
  display: inline-flex;
  border-radius: 3px;
  background-color: #df4a32;
  color: white;
  align-items: center;
  font-size: 1rem;
  height: 2.285em;
  line-height: 1.5;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  justify-content: center;
  padding-right: 0.75em;
  text-align: center;
  white-space: nowrap;
}
.google-button__icon {
  display: inline-block;
  vertical-align: middle;
  margin: 8px;
  width: 20px;
  height: 15px;
  font-size: 18px;
  box-sizing: border-box;
}
.google-text {
  padding-top:2px;
}
</style>



// WEBPACK FOOTER //
// index.vue?8d8728c6